export const DISPLAY_OPTIMIZED_BLOCK_SIZE = '30px';